import RevalidationTag from '@ravago/shared/page-data/enums/revalidation-tags/tags';

import { createClient as createContentfulClient } from 'contentful';

import { getServerConfig } from '../config/config.utils';

import { resolveContentfulDeliveryToken } from './token.utils';

export const createClient = (tags: Array<RevalidationTag> = []) => {
  const { contentful, cmsEnvironment } = getServerConfig();

  const host = contentful.preview ? 'preview.contentful.com' : 'cdn.contentful.com';
  const accessToken = resolveContentfulDeliveryToken(contentful, 'next-data-access:client');

  return createContentfulClient({
    space: contentful.spaceId,
    environment: cmsEnvironment,
    accessToken,
    host,
    adapter: async (config: any) => {
      const params = new URLSearchParams(config.params);
      const url = `${config.baseURL}/${config.url}?${params}`;

      const response = await fetch(url, {
        headers: config.headers,
        cache: contentful.preview ? 'no-cache' : 'force-cache',
        next: {
          tags: [RevalidationTag.all, ...tags]
        }
      } as RequestInit);

      return {
        data: await response.text(),
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        config
      };
    }
  });
};
